import * as React from 'react';
import { flow, map, get, forEach } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, Form, ControlLabel, FormGroup, Row, Modal, Button} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import {Field, formValueSelector, getFormValues, InjectedFormProps, reduxForm} from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {
  IChannel,
  ICustomer,
  IDocument,
  IPolicyApplication,
  IPremium,
  IProduct,
  IVehicle,
  QuoteStatus,
} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import * as moment from 'moment';
import {displayCurrency, getAvailableQuote, getReferralsAndDeclines} from '../../../../util/helpers';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import * as api from '../../../../data/api/api';
import FieldFormControl from '../../../../components/FieldFormControl';
import {isRequired} from '../../../../util/validators';
import FaCheck from 'react-icons/fa/check';
import Slider from '../../../../components/Slider';

const HIGH_WEIGHTS = ['12.51T - 18.00T', '18.01T - 26.00T', '26.01T - 32.00T', '32.01T - 38.00T', '38.01T and over'];

interface IQuoteFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  endDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };
  compulsoryExcess?: number;
  personalCustomer: boolean;
  insured: ICustomer;
  vehicles: IVehicle[];
  vehicleCount: number;
  voluntaryExcessEnabled: string;
  voluntaryExcess: string;
  premium: IPremium;
  formValues: IPolicyApplication;
  breakdownWordingDocument: IDocument;
  informationDeclaration: string;
}

class QuoteForm extends React.Component<IQuoteFormProps> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    referred: false,
    showBreakdown: true,
    compulsoryExcessType: '',
    showBreakdownModal: false,
  };

  public componentDidMount() {
    const { quote, actions, dispatch, change, vehicles } = this.props;

    if (quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      actions.quote.saveQuote(true);
    }

    forEach (vehicles, (horsebox) => {
      if (HIGH_WEIGHTS.includes(horsebox.weight)) {
        this.setState({ showBreakdown: false });
      }
    });

    this.checkDeclinesAndReferrals();

    const schemeId = get(quote, 'quotes.standard.annual.scheme.id');
    if (schemeId) {
      api.vehicleExcesses(schemeId, quote.application.vehicles)
        .then((result) => {
          forEach (result.meta, (vehicles, type) => {
            forEach (vehicles, (vehicle, index) => {
              dispatch(change('vehicles.' + index + '.excessTheftLockedBuilding',
                vehicle.excess_theft_locked_building));
              dispatch(change('vehicles.' + index + '.excessTheftOther', vehicle.excess_theft_other));
              dispatch(change('vehicles.' + index + '.excessAdft', vehicle.excess_adft));
            });
          });
        });
    }

    let compulsoryExcessType = 'None';
    forEach(vehicles, (horsebox) => {
      if (horsebox.coverType === 'Third Party, Fire and Theft' || horsebox.coverType === 'Fire and Theft') {
        compulsoryExcessType = 'Fire & Theft';
      }
    });
    forEach(vehicles, (horsebox) => {
      if (horsebox.coverType === 'Comprehensive') {
        compulsoryExcessType = 'Accidental Damage Fire & Theft';
      }
    });
    this.setState({compulsoryExcessType});
  }

  public componentWillReceiveProps(nextProps) {
    this.checkDeclinesAndReferrals();
    this.checkBreakdownChange(nextProps);
    this.checkVoluntaryExcessChange(nextProps);
  }

  private checkBreakdownChange(nextProps) {
    const { actions, vehicles } = this.props;

    if (vehicles) {
      forEach(nextProps.vehicles, (vehicle, index) => {
        if (vehicle.breakdownCover !== vehicles[index].breakdownCover) {
          actions.quote.calculate(nextProps.formValues);
        }
      });
    }
  }

  private checkVoluntaryExcessChange(nextProps) {
    const { actions, voluntaryExcess } = this.props;

    if (voluntaryExcess !== nextProps.voluntaryExcess) {
      actions.quote.calculate(nextProps.formValues);
    }
  }

  private checkDeclinesAndReferrals() {
    const { quote, actions } = this.props;

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (this.state.declines !== referralsAndDeclines.declines) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (this.state.referrals !== referralsAndDeclines.referrals) {
      this.setState({referrals: referralsAndDeclines.referrals});
      if (! this.state.referred && !referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({referred: true});
        actions.quote.referralQuote(
          quote.application.id, referralsAndDeclines.referrals,
        );
      }
    }
    if (this.state.errors !== referralsAndDeclines.errors) {
      this.setState({ errors: referralsAndDeclines.errors });
    }
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
          channel={this.props.channel}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/drivers'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private handleSlider = (event) => {
    const { change, dispatch } = this.props;
    if (event.length > 0) {
      let result = event[0];
      if (result > 500 && result < 750) {
        result = 750;
      } else if (result > 750 && result < 1000) {
        result = 1000;
      }
      dispatch(change('voluntaryExcess', result.toString()));
    }
  }

  private checkSliderJumps(percent) {
    if (percent > 50 && percent < 75) {
      percent = 75;
    } else if (percent > 75 && percent < 100) {
      percent = 100;
    }

    return [ percent, percent * 10 ];
  }

  private noVoluntaryExcess = () => {
    const { dispatch, change } = this.props;

    dispatch(change('voluntaryExcess', '0'));
  }

  private handleCloseBreakdownModal = () => {
    this.setState({
      showBreakdownModal: false,
    });
  }

  private handleOpenBreakdownModal = () => {
    this.setState({
      showBreakdownModal: true,
    });
  }

  private renderBreakdownCover = () => {
    const { vehicles, premium, breakdownWordingDocument } = this.props;
    const { showBreakdown, showBreakdownModal } = this.state;

    const breakdownPremiums = premium.information.breakdownCover.value;

    const displayBreakdownValue = (registration, value) => {
      if (!value) {
        return <div />;
      }
      return (
        <div>
          {registration} ({`£${value.toFixed(2)}`})
        </div>
      );
    };

    const breakdownVehicles = vehicles ? Object.values(vehicles).map((vehicle, key) => {
      return (
        <div key={key}>
          {!HIGH_WEIGHTS.includes(vehicle.weight) && (
            <Row>
              <Col componentClass={ControlLabel} sm={6}>
                {displayBreakdownValue(vehicle.registrationNumber, get(breakdownPremiums, vehicle.registrationNumber))}
              </Col>
              <Col sm={6}>
                <Col sm={12}>
                  <Row className="button-group-container">
                    <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                      <Field
                        name={`vehicles[${key}].breakdownCover`}
                        type="radio"
                        value="false"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      >
                        <div className={'button-group-btn'}>
                          No
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                    <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                      <Field
                        name={`vehicles[${key}].breakdownCover`}
                        type="radio"
                        value="true"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      >
                        <div className={'button-group-btn'}>
                          Yes
                          <FaCheck/>
                        </div>
                      </Field>
                    </Col>
                  </Row>
                </Col>
              </Col>
            </Row>
          )}
        </div>
      );
    }) : <div />;

    return (
      showBreakdown ? (
        <div className="sub-content-container">
          <Row>
            <Col sm={12}>
              <h3>Do you require breakdown cover?</h3>
              <p>Please <a href="#" onClick={this.handleOpenBreakdownModal}>click here</a> for
                more information about breakdown cover.</p>
              {breakdownVehicles}
            </Col>
          </Row>
          <Modal show={showBreakdownModal} onHide={this.handleCloseBreakdownModal}>
            <Modal.Header closeButton={true} className="modal-background-tertiary sub-content-container-alt-modal">
              <div className="title-no-border">Breakdown Cover</div>
            </Modal.Header>
            <Modal.Body>
              <div className="contact-modal-container">
                <ul>
                  <li>Assistance 24 hours a day, 365 days a year.</li>
                  <li>National coverage.</li>
                  <li>Uses a countrywide network of specialist recovery agents who have been selected for their ability
                    to care for your horses.</li>
                  <li>Payment of up to one hour’s labour at the scene of the breakdown.</li>
                  <li>Recovery of your vehicle to a local garage if it cannot be repaired at the roadside.</li>
                  <li>If the repair cannot be carried out the same day, the cost of transporting your vehicle and your
                    passengers home, or if you would prefer and it is closer, your original destination.</li>
                  <li>Help with alternative transport costs and overnight accommodation.</li>
                  <li>Our message service to let your family and/or colleagues know about your breakdown.</li>
                  <li>Alternative transport following the theft of your vehicle.</li>
                  <li>Home assist cover.</li>
                  <li>Recovery and onward transportation or the return home of any horse(s) traveling in the vehicle.
                  </li>
                </ul>
                <p>Please <a href={breakdownWordingDocument.filePath} target="_blank">click here</a> to view the
                  breakdown policy wording</p>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                bsStyle="primary"
                onClick={this.handleCloseBreakdownModal}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      ) : (
        <div />
      )
    );
  }

  private renderExcess = () => {
    const { voluntaryExcess, voluntaryExcessEnabled, compulsoryExcess, renderDefinition } = this.props;
    const { compulsoryExcessType } = this.state;

    let compulsoryExcessDisplay = 'None';
    if (compulsoryExcessType !== 'None') {
      compulsoryExcessDisplay = '£'
        + displayCurrency(compulsoryExcess ? compulsoryExcess : 100, ',', true) + ' '
        + compulsoryExcessType;
    }

    return (
      <>
        <Row>
          <Col sm={12}>
            <h3>Excess</h3>
          </Col>
        </Row>
        <Col className="vehicle-box">
          <Row className="quick-vehicle-body margin-bottom">
            <Col sm={2}>
              <div className="quick-excess-icon">
                <img src={require('../../img/excess.svg')} alt="" />
              </div>
            </Col>
            <Col sm={10} className="excess-padding-left">
              <Row>
                <Col sm={8} className="vehicle-questions vehicle-info-centre">
                  {renderDefinition('b2c_vehicle_voluntary_excess')}
                  Would you like to add a voluntary excess?
                </Col>
                <Col sm={4}>
                  <FormGroup controlId="voluntary_excess_show">
                    <Row className="button-group-container">
                      <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                        <Field
                          name="voluntaryExcessEnabled"
                          type="radio"
                          value="false"
                          component={FieldFormControl}
                          validate={[ isRequired ]}
                          onClick={this.noVoluntaryExcess}
                        >
                          <div className={'button-group-btn'}>
                            No
                            <FaCheck/>
                          </div>
                        </Field>
                      </Col>
                      <Col sm={6} className="button-group-btn-container no-padding-horizontal">
                        <Field
                          name="voluntaryExcessEnabled"
                          type="radio"
                          value="true"
                          component={FieldFormControl}
                          validate={[ isRequired ]}
                        >
                          <div className={'button-group-btn'}>
                            Yes
                            <FaCheck/>
                          </div>
                        </Field>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
              {voluntaryExcessEnabled === 'true' && (
                <FormGroup controlId={'voluntary_excess'}>
                  <Col className="vehicle-questions" sm={8}>
                    Please select Voluntary excess amount:
                  </Col>
                  <Col sm={4}>
                    <div className="full-name-fields">
                      <Row>
                        <Col sm={12}/>
                      </Row>
                    </div>
                  </Col>
                  <Row>
                    <Col sm={12} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                      <Slider
                        tickValues={[0, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 750, 1000]}
                        jumpPercents={this.checkSliderJumps}
                        handleColor="#EF8D00"
                        trackColor="#EF8D00"
                        onChange={this.handleSlider}
                        value={voluntaryExcess ? voluntaryExcess : 0}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              )}
              <Row>
                <Col sm={6}>
                  Compulsory Policy Excess
                </Col>
                <Col sm={6}>
                  {compulsoryExcessDisplay}
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  Compulsory Vehicle Excess
                </Col>
                <Col sm={6}>
                  Refer to Individual vehicle for details
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h3>Young & inexperienced driver excess</h3>
            </Col>
          </Row>
          <div className="sub-content-container-alt vehicle-excess-table">
            <Row>
              <Col sm={12}>
                Young & inexperienced driver excess (does not apply to Agricultural vehicles)
              </Col>
            </Row>
            <Row>
              <Col sm={8}>
                Where driver is aged 21 years or below
              </Col>
              <Col sm={4}>
                £{displayCurrency(250, ',')}
              </Col>
            </Row>
            <Row>
              <Col sm={8}>
                Where driver is aged 22-24 years
              </Col>
              <Col sm={4}>
                £{displayCurrency(200, ',')}
              </Col>
            </Row>
            <Row className="no-border">
              <Col sm={8}>
                Where a driver aged 25 years or more has not held their full relevant UK/EU driving license at
                least 12 months
              </Col>
              <Col sm={4}>
                £{displayCurrency(200, ',')}
              </Col>
            </Row>
          </div>
        </Col>
      </>
    );
  }

  private renderPremium = () => {
    const { premium } = this.props;

    let taxExcBreakdown = premium.tax;
    let breakdownTax = 0.00;
    let breakdownGross = 0.00;
    const included = premium.information.breakdownCover.included;
    forEach(included, (val, reg) => {
      if (val) {
        taxExcBreakdown -= get(premium.information.breakdownCover.tax, reg, 0);
        breakdownTax += get(premium.information.breakdownCover.tax, reg, 0);
        breakdownGross += get(premium.information.breakdownCover.gross, reg, 0);
      }
    });

    return (
      <>
        {premium.gross > 0 && (
          <div className="sub-content-container-alt alt-background">
            <div className="premium-body">
              <div className="premium-icon visible-xs-block hidden-xs">
                <img src={require('../../img/tick_list_white.svg')} alt="" />
              </div>
              <div className="premium-content">
                <div className="premium-row-title">
                  <div className="premium-item-title">
                    Total Premium
                  </div>
                  <div className="premium-result-title">
                    £{displayCurrency(premium.gross, ',')}
                  </div>
                </div>
                <div className="premium-row">
                  <div className="premium-item-title">
                    Insurance Premium Tax (IPT)
                  </div>
                  <div className="premium-item">
                    £{displayCurrency(taxExcBreakdown, ',')}
                  </div>
                </div>
                <div className="premium-row">
                  <div className="premium-item-title">
                    Breakdown Insurance Premium Tax (IPT)
                  </div>
                  <div className="premium-item">
                    £{displayCurrency(breakdownTax, ',')}
                  </div>
                </div>
                <div className="premium-row">
                  <div className="premium-item-title">
                    Breakdown Premium including IPT
                  </div>
                  <div className="premium-item">
                    £{displayCurrency(breakdownGross, ',')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  private renderCoverInformation = () => {
    const { personalCustomer, insured, startDate, endDate, vehicles } = this.props;

    if (!insured) {
      return <div />;
    }

    const renderVehicles = map(vehicles, (vehicle: IVehicle, key: number) => {
      return (
        <div key={key}>
          <div className="cover-information-row no-border">
            {vehicle.registrationNumber}
          </div>
          <div className="cover-information-row no-border">
            Vehicle Make:
            <span className="cover-information-detail">{vehicle.make}</span>
          </div>
          <div className="cover-information-row no-border">
            Vehicle Model:
            <span className="cover-information-detail">{vehicle.model}</span>
          </div>
          <div className="cover-information-row no-border">
            Year of Make:
            <span className="cover-information-detail">{vehicle.year}</span>
          </div>
          <div className="cover-information-row no-border">
            Body Type:
            <span className="cover-information-detail">{vehicle.bodyType}</span>
          </div>
          <div className="cover-information-row no-border">
            Value:
            <span className="cover-information-detail">£{displayCurrency(vehicle.value, ',')}</span>
          </div>
          <div className="cover-information-row">
            Cover:
            <span className="cover-information-detail">{vehicle.coverType}</span>
          </div>
        </div>
      );
    });

    return (
      <div className="sub-content-container-alt">
        <div className="margin-bottom">
          <Row className="declaration-sub-content-container-alt">
            <Col sm={12}>
              Please carefully review and confirm the information provided is accurate. As this information is what your
              insurance cover and premium will be based on. If the information is not accurate, please make the required
              corrections before continuing.
            </Col>
            <Col sm={12}>
              <Row className="declaration-button-group-container pull-right">
                <Col sm={6} md={6} lg={6} className="button-group-btn-container">
                  <Field
                    name="informationDeclaration"
                    type="radio"
                    value="true"
                    component={FieldFormControl}
                  >
                    <div className="button-group-btn">
                      Yes
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
                <Col sm={6} md={6} lg={6} className="button-group-btn-container">
                  <Field
                    name="informationDeclaration"
                    type="radio"
                    value="false"
                    component={FieldFormControl}
                  >
                    <div className="button-group-btn">
                      No
                      <FaCheck/>
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        {personalCustomer ? (
          <div>
            <div className="cover-information-row height-cover-dates-mobile">
              Cover Dates:
              <span className="cover-information-detail">{startDate} to {moment(endDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className="cover-information-row">
              Proposer Name:
              <span className="cover-information-detail">{insured.title} {insured.firstName} {insured.lastName}</span>
            </div>
            <div className="cover-information-row">
              Proposer Date of Birth:
              <span className="cover-information-detail">{insured.dob}</span>
            </div>
            <div className="cover-information-row height-email-address-mobile">
              Email Address:
              <span className="cover-information-detail">{insured.email}</span>
            </div>
            <div className="cover-information-row height-cover-dates-mobile">
              Phone Number:
              <span className="cover-information-detail">{insured.phone1}</span>
            </div>
            <div className="cover-information-row">
              Proposer Correspondence Address:
              <span className="cover-information-detail">{insured.address.line1}</span><br />
              {insured.address.line2 && insured.address.line2 !== '' && (
                <><span className="cover-information-detail">{insured.address.line2}</span><br /></>
              )}
              <span className="cover-information-detail">{insured.address.town}</span><br />
              <span className="cover-information-detail">{insured.address.county}</span><br />
              <span className="cover-information-detail">{insured.address.postcode}</span><br />
            </div>
          </div>
        ) : (
          <div>
            <div className="cover-information-row height-cover-dates-mobile">
              Cover Dates:
              <span className="cover-information-detail">{startDate} to {moment(endDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className="cover-information-row">
              Company Name:
              <span className="cover-information-detail">{insured.companyName}</span>
            </div>
            <div className="cover-information-row">
              Trading Name:
              <span className="cover-information-detail">{insured.metadata.tradingName}</span>
            </div>
            <div className="cover-information-row">
              Company Registration Number:
              <span className="cover-information-detail">{insured.metadata.companyRegistrationNumber}</span>
            </div>
            <div className="cover-information-row height-email-address-mobile">
              Email Address:
              <span className="cover-information-detail">{insured.email}</span>
            </div>
            <div className="cover-information-row height-cover-dates-mobile">
              Phone Number:
              <span className="cover-information-detail">{insured.phone1}</span>
            </div>
            <div className="cover-information-row">
              Year Company Established:
              <span className="cover-information-detail">{insured.metadata.year}</span>
            </div>
            <div className="cover-information-row">
              Company Correspondence Address:
              <span className="cover-information-detail">{insured.address.line1}</span><br />
              {insured.address.line2 && insured.address.line2 !== '' && (
                <><span className="cover-information-detail">{insured.address.line2}</span><br /></>
              )}
              <span className="cover-information-detail">{insured.address.town}</span><br />
              <span className="cover-information-detail">{insured.address.county}</span><br />
              <span className="cover-information-detail">{insured.address.postcode}</span><br />
            </div>
          </div>
        )}
        {renderVehicles}
      </div>
    );
  }

  public render() {
    const { handleSubmit, quote, informationDeclaration } = this.props;
    const { declines, referrals, referred } = this.state;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declines.length > 0 || referrals.length > 0 || referred || declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const hasBackButton = quote.application.status !== QuoteStatus.REFERRAL_APPROVED;

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <div className="sub-content-container">
            {this.renderPremium()}
            {this.renderBreakdownCover()}
            {this.renderExcess()}

            <div className="sub-content-container-alt">
              <h3>Cover Information</h3>
              {this.renderCoverInformation()}
            </div>
          </div>
          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/drivers'}
            {...this.props}
            nextButtonDisabled={informationDeclaration !== 'true'}
            hasSaveButton={true}
            calculateOnSave={true}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const personalCustomer = selector(state, 'personalCustomer');
      const insured = selector(state, 'insured');
      const vehicles = selector(state, 'vehicles');
      const vehicleCount = selector(state, 'vehicleCount');
      const compulsoryExcess = selector(state, 'compulsoryExcess');
      const voluntaryExcessEnabled = selector(state, 'voluntaryExcessEnabled');
      const voluntaryExcess = selector(state, 'voluntaryExcess');
      const informationDeclaration = selector(state, 'informationDeclaration');
      const premium = getAvailableQuote(state.quote).pop();
      const formValues = getFormValues('quote')(state);
      const channel = state.branding.channel;

      let breakdownWordingDocument = null;
      forEach(channel.productDocuments, (document) => {
        if (['Policy Wording: Horsebox Breakdown'].includes(document.name)) {
          breakdownWordingDocument = document;
        }
      });

      return {
        startDate,
        endDate,
        quotationTypes,
        personalCustomer,
        insured,
        vehicles,
        vehicleCount,
        compulsoryExcess,
        voluntaryExcessEnabled,
        voluntaryExcess,
        informationDeclaration,
        premium,
        formValues,
        breakdownWordingDocument,
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(QuoteForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Quote/index.tsx